<template>
    <div class="card border-light rounded-3 shadow-lg">
        <div class="card-body">
            <h2 class="card-title h4 mb-4 text-primary">Mode de réception du code de connexion</h2>

            <form @submit.prevent="submitForm">
                <div class="mb-3">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            id="otp-sms-profile"
                            value="sms"
                            v-model="channel"
                            :disabled="!hasMobile"
                        />
                        <label class="form-check-label" for="otp-sms-profile">
                            Recevoir le code par SMS
                            <span v-if="!hasMobile" class="text-muted">(numéro de mobile requis)</span>
                        </label>
                    </div>
                    
                    <div class="form-check mt-2">
                        <input
                            class="form-check-input"
                            type="radio"
                            id="otp-email-profile"
                            value="email"
                            v-model="channel"
                        />
                        <label class="form-check-label" for="otp-email-profile">Recevoir le code par e-mail</label>
                    </div>
                </div>

                <div class="mb-3">
                    <small class="text-muted">
                        Cette préférence sera utilisée automatiquement à chaque connexion.
                    </small>
                </div>

                <div v-if="alert"
                    :class="'my-2 alert' + (alert ? ' alert-' + alert.class : '') + ' text-center p-1 fs-n1' + (!alert ? ' invisible' : '')"
                    role="alert"
                    v-html="alert ? alert.message : '&nbsp;'"
                ></div>

                <button type="submit" class="btn btn-primary rounded-pill" :disabled="loading">Enregistrer</button>
            </form>
        </div>
    </div>

    <div v-if="showConfirm" class="popup">
        <div class="popup-inner">
            <h5 class="card-title h4 mb-4 text-primary">Confirmer le mode de reception</h5>

            <div class="mb-3">
                <p>Pour une sécurité renforcée, nous vous recommandons de conserver le mode de réception par SMS.</p> 
                <p>Pour confirmer le changement, veuillez renseigner ci-dessous le code que vous recevrez par email en cliquant&nbsp;<button class="btn btn-primary btn-sm mb-1" @click="sendCode()">ici</button></p>
            </div>

            <div class="flex-column flex-md-row gap-3 flex-grow-1">
                <input
                    type="text"
                    id="otp"
                    v-model="otpCode"
                    class="form-control"
                    maxlength="6"
                    pattern="[0-9]{6}"
                    placeholder="Saisissez le code à 6 chiffres"
                    required
                />
            </div>

            <div v-if="alertOTP"
                :class="'my-2 alert' + (alertOTP ? ' alert-' + alertOTP.class : '') + ' text-center p-1 fs-n1' + (!alertOTP ? ' invisible' : '')"
                role="alert"
                v-html="alertOTP ? alertOTP.message : '&nbsp;'"
            ></div>
    
            <div class="pt-3 d-flex justify-content-end">
                <button class="btn btn-success rounded-pill popup-confirm w-50" :disabled="!otpCode" @click="updateChannel()">Valider</button>
                <button class="btn btn-secondary rounded-pill popup-close w-50" @click="hidePopup()">Annuler</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'ChangeOtpChannelForm',
    data: () => ({
        channel: 'email',
        loading: false,
        alert: null,
        alertOTP: null,
        showConfirm: false,
        otpCode: '',
    }),
    computed: {
        ...mapGetters(['getUser']),
        hasMobile() {
            return !!this.getUser.tel_mobile && this.getUser.tel_mobile != 'no_mobile'
        },
    },
    methods: {
        ...mapActions(['updateOtpChannel', 'sendCodeVerif']),
        async submitForm() {
            if(this.channel == 'email') {
                this.alertOTP = null
                this.showConfirm = true
                return
            }

            await this.updateChannel()
        },
        hidePopup() {
            this.showConfirm = false
        },
        async sendCode() {
            this.loading = true
            this.alertOTP = await this.sendCodeVerif()
            this.loading = false
        },
        async updateChannel() {
            this.loading = true
            this.alertOTP = await this.updateOtpChannel({
                channel: this.channel,
                code: this.otpCode
            })
            this.otpCode = ''
            if(this.alertOTP.class === 'success') {
                this.showConfirm = false
                this.alert = this.alertOTP
            }
                this.loading = false
        },
    },
    mounted() {
        this.channel = this.getUser.otp_channel === 'email' || !this.hasMobile ? 'email' : 'sms'
    },
}
</script>

